import { createFileRoute } from '@tanstack/react-router';
import AuthenticateRoute from 'src/components/organisms/app-layouts/authenticate-route/authenticate-route';
import { PropertyEditorPage } from 'src/modules/catalog/components/pages/property-editor.page';
import { propertiesSearchSchema } from 'src/modules/catalog/schemas/properties-search.schema';

export const Route = createFileRoute('/catalog/properties/create')({
  component: CatalogPropertiesCreateComponent,
  validateSearch: (search) => propertiesSearchSchema.parse(search),
});

function CatalogPropertiesCreateComponent() {
  const search = Route.useSearch();

  return (
    <AuthenticateRoute>
      <PropertyEditorPage backSearch={search} />
    </AuthenticateRoute>
  );
}

export default Route;
